import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { addCarouselShows, CAROUSEL_QUERY_KEY } from "./api";
import { AddCarouselShowsResponse } from "@punchup/data/models";

interface AddCarouselShowsParams {
  venuePageId: string;
  showIds: string[];
}

/**
 * Hook to bulk add shows to the carousel
 */
export function useAddCarouselShows(): UseMutationResult<
  AddCarouselShowsResponse,
  Error,
  AddCarouselShowsParams
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ venuePageId, showIds }: AddCarouselShowsParams) =>
      addCarouselShows(venuePageId, { showIds }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [CAROUSEL_QUERY_KEY, variables.venuePageId],
      });
    },
  });
}
